export default "__VITE_ASSET__TSHzDc_C__"